import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @extends {Base<ComponentProps>}
 */
export default class FeaturedWorks extends Base {
  panelOpen = false;

  breakpoints = ['xxs', 'xs'];

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'FeaturedWorks',
    refs: ['items[]', 'pictures[]', 'mobilePanel', 'mobilePanelContent', 'close'],
  };

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * Mouse over on items
   * @param  {object} e current Element
   * @returns {void}
   */
  onItemsMouseenter(e) {
    const { slug } = e.currentTarget.dataset;

    this.$refs.pictures.forEach((element) => {
      element.classList.remove('opacity-100');
      element.classList.add('opacity-0');
    });

    document.querySelector(`[data-picture="${slug}"]`).classList.add('opacity-100');
  }

  /**
   * Click on mobile and open Panel
   * @param  {object} e current item
   * @returns {void}
   */
  onItemsClick(e) {
    if (this.isMobile) {
      e.preventDefault();
      this.$refs.mobilePanel.classList.add('translate-y-full');

      const htmlPanelTemplate = e.currentTarget.querySelector('template').innerHTML;

      setTimeout(() => {
        this.$refs.mobilePanelContent.innerHTML = htmlPanelTemplate;
        this.$refs.mobilePanel.classList.remove('translate-y-full');
      }, 100);
    }
  }

  /**
   * Close Panel
   * @returns {void}
   */
  onCloseClick() {
    this.$refs.mobilePanel.classList.add('translate-y-full');
  }
}
